import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function waLink(whatsapp, text) {
  return `https://wa.me/${whatsapp}?text=${encodeURIComponent(text)}`;
}

export function formatApiError(e, fallback = "Ocurrió un error. Intenta de nuevo.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
